import clsx from 'clsx';
import React from 'react';

import CheckMark from 'images/check_mark.svg';

import styles from './styles.module.scss';

type topMarginTypes = 'Medium' | 'Large';

const Benefits = ({
  benefits,
  shrinkTextOnMobile,
  topMargin,
}: {
  benefits: string[];
  shrinkTextOnMobile?: boolean;
  topMargin: topMarginTypes;
}) => {
  return (
    <div className={clsx(styles.benefits, styles[`containerMargin${topMargin}`])}>
      {benefits.map((benefit) => (
        <div className={styles.itemContainer} key={benefit}>
          <div className={styles.imgContainer}>
            <img className={styles.img} src={CheckMark} width="20" />
          </div>
          <div
            className={clsx(styles.itemDescription, {
              [styles.shrinkTextOnMobile]: shrinkTextOnMobile,
            })}
          >
            {benefit}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Benefits;
